module.exports = __webpack_public_path__ + "media/images/profile/message-sent-3d7b054f593e828cd22f204f5bf219a7.svg";